import moment from 'moment-timezone'
import { isDigitalOption } from 'apps/marketplace/utils/helpers/isDigitalOption'
import { IShipmentCoverInfoQuery } from '../graphql/ShipmentCoverData'
import { TCoverModalSchema } from '../schema/CoverModalSchema'
import { ICoverModalCarrierOption } from '../types'

interface IGetCoverModalSchema {
  shipment: IShipmentCoverInfoQuery['shipment']
  carrierOption?: ICoverModalCarrierOption
}

export const getCoverModalSchema = ({
  carrierOption,
  shipment,
}: IGetCoverModalSchema): TCoverModalSchema => {
  const { coveredBid, firstPickup } = shipment || {}

  const bid = coveredBid || carrierOption
  const {
    amount,
    carrierApplication,
    carrierContactName,
    carrierContactPhone,
    carrierContactPhoneExt,
    carrierContactUser: dispatcher,
    carrierContactUserId,
  } = bid || {}

  const { createdBy, source: carrierOptionSource } = carrierOption || {}
  const { fullName: createdByName, id: createdById } = createdBy || {}
  const isDigital = isDigitalOption(carrierOptionSource)

  const dispatcherId = isDigital && !carrierContactUserId ? createdById : carrierContactUserId
  const bookingContactName = isDigital && !carrierContactName ? createdByName : carrierContactName

  const { carrierAvailableTruck, driver, notes } = coveredBid || {}
  const { id: carrierApplicationId } = carrierApplication || {}
  const { email: dispatcherEmail } = dispatcher || {}
  const { cellPhone: driverCellPhone, id: driverId } = driver || {}
  const { trailerNumber, truckLocation, truckNumber, vin } = carrierAvailableTruck || {}
  const { city: truckCity, stateCode: truckState } = truckLocation || {}

  const [firstNote] = notes || []
  const { callBackAt } = firstNote || {}

  const { appointment: firstPickupAppointment } = firstPickup || {}
  const { startAt: firstPickupAppointmentStartAt } = firstPickupAppointment || {}

  const laterOrNone = firstPickupAppointmentStartAt ? 'later' : null
  const assignDriverTime = driverId ? 'now' : laterOrNone

  const etaDate = assignDriverTime ? new Date(firstPickupAppointmentStartAt || '') : null
  const etaTime = assignDriverTime ? moment(firstPickupAppointmentStartAt).format('h:mma') : null

  const facility =
    truckCity && truckState
      ? {
          location: {
            id: '-1',
            state: truckState,
            city: truckCity,
            label: `${truckCity}, ${truckState}`,
          },
        }
      : null

  return {
    additionalCarrierInfo: null,
    carrierApplicationId: carrierApplicationId || '',
    carrierContactId: dispatcherId || '',
    bookingContactName: bookingContactName || '',
    bookingContactPhone: carrierContactPhone || '',
    bookingContactPhoneExt: carrierContactPhoneExt || '',
    bookingContactEmail: dispatcherEmail || '',
    rate: amount || null,
    assignDriverTime,
    driverId: driverId || null,
    driverContactPhone: driverCellPhone || '',
    vinNumber: vin || '',
    truckNumber: truckNumber || '',
    trailerNumber: trailerNumber || '',
    useCustomCallback: callBackAt ? 'yes' : 'no',
    etaDate,
    etaTime,
    etaDriverLocation: facility,
    callbackDate: null,
    callbackTime: null,
    lateReason: null,
    trackingRequired: false,
  }
}
